import Sortable from "sortablejs/Sortable";

const createSortable = (el, options, vnode) => {
  return Sortable.create(el, {
    ...options
  });
};

const sortable = {
  name: 'sortable',
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(table.querySelector("tbody"), binding.value, vnode);
  }
};

export default sortable;
